import { combineEpics } from "redux-observable";
import { v as vivaceEpics } from "../Vivace.epics-e2cdc8fc.js";
import { draftMetricsQueryStringEpics } from "./views/VivaceUserContext.epics.js";
import { metricEpics } from "./views/Metric/Metric.epics.js";
const rootEpic = combineEpics(vivaceEpics, draftMetricsQueryStringEpics, metricEpics);
export {
  rootEpic
};
//# sourceMappingURL=epics.js.map
